export var LanguageKey;
(function (LanguageKey) {
  LanguageKey["English"] = "english";
  LanguageKey["French"] = "french";
})(LanguageKey || (LanguageKey = {}));